export default __webpack_public_path__ + "static/media/vpWT.7a7bf939.svg";